const globalConfig = {
    created(){
        //用于二开时传递子组件的this给二开组件
        this.$emit('setChildThis',this);
    }
}
export {globalConfig}